"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.alertTypes = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@mui/styles");
var _styles2 = require("./styles");
var _AlertLink = _interopRequireDefault(require("./AlertLink"));
var _AlertIcon = _interopRequireDefault(require("./AlertIcon"));
var _AlertHeader = _interopRequireDefault(require("./AlertHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const alertTypes = exports.alertTypes = {
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
  INFO: "info"
};
const backgroundColor = {
  error: alertTypes.ERROR,
  success: alertTypes.SUCCESS,
  warning: alertTypes.WARNING,
  info: alertTypes.INFO
};
const AlertBox = _ref => {
  let {
    classes,
    message,
    type,
    link,
    linkTo,
    children,
    icon,
    header
  } = _ref;
  if (children) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.messageBox, classes[backgroundColor[type]])
    }, children);
  }
  if (message) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.alertBoxContainer, classes[backgroundColor[type]])
    }, /*#__PURE__*/_react.default.createElement(_AlertIcon.default, {
      icon: icon
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.content
    }, /*#__PURE__*/_react.default.createElement(_AlertHeader.default, {
      header: header
    }), /*#__PURE__*/_react.default.createElement("div", null, message), /*#__PURE__*/_react.default.createElement(_AlertLink.default, {
      link: link,
      linkTo: linkTo
    })));
  }
  return null;
};
AlertBox.propTypes = {
  type: _propTypes.default.oneOf(["error", "success", "warning", "info"]),
  message: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])
};
AlertBox.defaultProps = {
  type: "error",
  message: undefined
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(AlertBox);